import { initVitePreloadErrorHandler } from "./lib/vite-preload-error";
import "./polyfills";
import axios from "axios";

// Initialize Vite preload error handler early to catch module loading failures
// This must be called before any dynamic imports occur
initVitePreloadErrorHandler();

window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
window.axios.defaults.withCredentials = true;
window.axios.defaults.baseURL = "/";
